
<div class="margin container">

  <data-table
  title='Terceros'
  [columns]='columnasTerceros'
  [configuration]='configurationTerceros'
  [reloadTable]='recargarTablaTerceros'
  (add)='agregarTerceros($event)'
  (edit)='editarTerceros($event)'
  [params]='[]'
  [url]='urlGetTerceros'
  (selection)='seleccionadosTerceros($event)'
  (clickRow)='clickFilaTerceros($event)'
  [headerFilters]="headerFilters"
  [moduleId]="1"
  [subModuleId]="2"
  ></data-table>


 </div>
